<template>
  <div class="login">
    <div class="login_mask" v-if="!flagShow">
      <div style="width: 60%;height: 100%;margin: 10% auto;">
        <div style="width: 90%;height: 15%;margin: 1% auto;color: white;font-size: 20px;text-align: center;">
          傲举招聘管理系统
        </div>
        <el-form ref="form" :model="form" label-position="left" @submit.native.prevent>
          <el-form-item label="">
            <el-input style="" prefix-icon="el-icon-user
                    " v-model="form.iuAccount" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <div style="margin-top: 5%;">
            <el-form-item label="">
              <el-input style="" prefix-icon="el-icon-lock
                      " show-password v-model="form.iuPw" placeholder="请输入密码"></el-input>
            </el-form-item>
          </div>

          <el-button type="primary" plain style="width: 100%;" @click="login">
            立即登录
          </el-button>
        </el-form>
      </div>
    </div>
    <div class="login_mask2" v-else>
      <div style="width: 60%;height: 100%;margin: 10% auto;">
        <div style="width: 90%;height: 15%;margin: 1% auto;color: white;font-size: 20px;text-align: center;">
          傲举招聘管理系统
        </div>
        <el-form ref="form" :model="form" label-position="left" @submit.native.prevent>
          <el-form-item label="">
            <el-input style="" prefix-icon="el-icon-user
                    " v-model="form.iuAccount" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <div style="margin-top: 5%;">
            <el-form-item label="">
              <el-input style="" prefix-icon="el-icon-lock
                      " show-password v-model="form.iuPw" placeholder="请输入密码"></el-input>
            </el-form-item>
          </div>

          <el-button type="primary" plain style="width: 100%;" @click="login">
            立即登录
          </el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapMutations, mapAction } from 'vuex'
import qs from "qs";
import {
  doLogin
} from "../api/api";
export default {
  name: 'doLogin',
  data() {
    return {
      flagShow: false,
      loginHeight: '',
      form: {
        iuAccount: "",
        iuPw: null,
      },
    }
  },
  mounted() {
    // 监听键盘事件
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false)
  },
  methods: {
    ...mapMutations(['changeuser']),
    keyDown(e) {
      //console.log(e)
      if (e.key == 'Enter') {
        this.login();
        e.preventDefault()//去掉默认的换行
      }
    },
    login() {
      if (this.form.iuAccount == '' || this.form.iuPw == '') {
        this.$message({
          showClose: true,
          message: '请输入用户名和密码',
          type: 'danger'
        });
      }
      // const s = qs.stringify(this.form)
      doLogin(this.form).then(res => {
        if (res.status == 200) {
          this.changeuser({ iuId: res.data })
          // 登录成功后跳转到权限加载页面
          this.$router.push({
            path: '/loading'
          })
    } else {
      this.$notify.error({
        title: '错误',
        message: res.msg
      });
    }

  })
}
  },
created() {
  this.loginHeight = window.innerHeight
  document.title = '傲举招聘管理系统';
  this.flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  if (this.flag) {
    this.flagShow = true;
  }
  if (localStorage.getItem('iuId')) {
    this.$router.push({
      path: '/loading'
    })
  }
},
mounted() {
  if (this.loginHeight < 800) {
    var oDiv = document.querySelector('.login_mask')
    oDiv.style.height = "55%";
    oDiv.style.width = "30%";


  }
},
activated() {


  document.title = '傲举招聘管理系统'

},
watch: {
  '$route'(to, from) {
    this.$router.go(0);
  }
},
}
</script>

<style scoped="scoped">
.login {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  margin: 0;
  padding: 0;
  font-family: "montserrat";
  background-image: linear-gradient(45deg, #2c3e50, #27ae60, #2980b9, #8e44ad);
  background-size: 400%;
  animation: bganimation 15s infinite;
}

.login_mask {
  width: 25%;
  height: 40%;
  margin: 12% 0 0 65%;
  overflow: hidden;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 10px 0 10px 0 rgba(255, 255, 255, 0.1)
}

@keyframes bganimation {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
